import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@stores/auth'
import Login from '@templates/login/Login.vue'
import Top from '@templates/top/Top.vue'
import Error from '@templates/error/Error.vue'
import Setting from '@templates/setting/Setting.vue'
import OrderSearch from '@templates/orderSearch/OrderSearch.vue'
import OrderResults from '@templates/orderResults/OrderResults.vue'
import OrderFavorite from '@templates/orderFavorite/OrderFavorite.vue'
import OrderCart from '@templates/orderCart/OrderCart.vue'
import OrderHistory from '@templates/orderHistory/OrderHistory.vue'
import ReturnSearch from '@templates/returnSearch/ReturnSearch.vue'
import ReturnBox from '@templates/returnBox/ReturnBox.vue'
import ReturnHistory from '@templates/returnHistory/ReturnHistory.vue'
import OrderFavoriteDetail from '@templates/orderFavoriteDetail/OrderFavoriteDetail.vue'
import { modalUtil } from '@functions/modalUtil'
import ChangePassword from '@templates/changePassword/ChangePassword.vue'
import ForgotPassword from '@templates/passwordReset/ForgotPassword.vue'
import ForgotPasswordComplete from '@templates/passwordReset/ForgotPasswordComplete.vue'
import ResetPassword from '@templates/passwordReset/ResetPassword.vue'
import PasswordReset from '@templates/password/PasswordReset.vue'
import PasswordChange from '@templates/setting/PasswordChange.vue'
import NewsList from '@templates/news/NewsList.vue'
import NewsDetail from '@templates/news/NewsDetail.vue'
import OrderTerms from '@templates/orderTerms/OrderTerms.vue'
import ReturnTerms from '@templates/returnTerms/ReturnTerms.vue'
import BarcodeScanTerms from '@templates/barcodeScanTerms/BarcodeScanTerms.vue'
import OrderScan from '@templates/orderScan/OrderScan.vue'
import ReturnScan from '@templates/returnScan/ReturnScan.vue'
import { useScanNavigationStore } from '@stores/scanNavigation'
import { setPostLoginRedirect, consumePostLoginRedirect } from '@functions/postLoginRedirect'
import { isNetworkError } from '@functions/offlineReturnPath'
import PdfViewerPage from '@templates/pdfViewer/PdfViewerPage.vue'
import EnifClubTerms from '@templates/enifClubTerms/EnifClubTerms.vue'
import EnifClubDocument from '@templates/enifClubDocument/EnifClubDocument.vue'
import Manual from '@templates/manual/Manual.vue'
import Environment from '@templates/environment/Environment.vue'
import Terms from '@templates/terms/Terms.vue'

const router = createRouter({
  history: createWebHistory('/front'),
  routes: [
    {
      path: '/login'
      , component: Login
      , requiresAuth: false
    },
    {
      path: '/'
      , component: Top
      , meta: {
        requiresAuth: true
      }
    },
    {
      path: '/news'
      , component: NewsList
      , meta: {
        requiresAuth: true
      }
    },
    {
      path: '/news/:newsId'
      , component: NewsDetail
      , meta: {
        requiresAuth: true
      }
    },
    {
      path: '/setting'
      , component: Setting
      , meta: {
        requiresAuth: true
        , title: '共創未来ポータル | ユーザー管理'
      }
    },
    {
      path: '/setting/password/change'
      , component: PasswordChange
      , meta: {
          title: '共創未来ポータル | パスワード変更'
      }
    },
    {
      path: '/order-search'
      , component: OrderSearch
      , meta: {
        requiresAuth: true
        , title: '共創未来ポータル | 発注TOP'
        , requiresOrderTerms: true
      }
    },
    {
      path: '/order-favorite'
      , component: OrderFavorite
      , meta: {
        requiresAuth: true
        , title: '共創未来ポータル | お気に入り'
        , requiresOrderTerms: true
      }
    },
    {
      path: '/order-favorite-detail'
      , component: OrderFavoriteDetail
      , meta: {
        requiresAuth: true
        , title: '共創未来ポータル | お気に入り詳細'
        , requiresOrderTerms: true
      }
    },
    {
      path: '/order-history'
      , component: OrderHistory
      , meta: {
        requiresAuth: true
        , title: '共創未来ポータル | 発注履歴'
        , requiresOrderTerms: true
      }
    },
    {
      path: '/order-cart'
      , component: OrderCart
      , meta: {
        requiresAuth: true
        , title: '共創未来ポータル | 発注カート'
        , requiresOrderTerms: true
      }
    },
    {
      path: '/order-results'
      , component: OrderResults
      , meta: {
        requiresAuth: true
        , title: '共創未来ポータル | 注文結果TOP'
      }
    },
    {
      path: '/return-search'
      , component: ReturnSearch
      , meta: {
        requiresAuth: true
        , title: '共創未来ポータル | 返品依頼TOP'
        , requiresReturnTerms: true
      }
    },
    {
      path: '/return-box'
      , component: ReturnBox
      , meta: {
        requiresAuth: true
        , title: '共創未来ポータル | 返品ボックス'
        , requiresReturnTerms: true
      }
    },
    {
      path: '/return-history'
      , component: ReturnHistory
      , meta: {
        requiresAuth: true
        , title: '共創未来ポータル | 返品履歴'
        , requiresReturnTerms: true
      }
    },
    {
      path: '/change-password'
      , component: ChangePassword
    },
    {
      path: '/forgot-password'
      , component: ForgotPassword
      , meta: {
        requiresAuth: false
        , title: '共想未来ポータル | パスワード再設定'
      }
    },
    {
      path: '/forgot-password/complete'
      , component: ForgotPasswordComplete
      , meta: {
        requiresAuth: false
        , title: '共想未来ポータル | パスワード再設定'
      }
    },
    {
      path: '/reset-password/:token'
      , component: ResetPassword
      , meta: {
        requiresAuth: false
        , title: '共創未来ポータル | パスワード再設定'
      }
    },
    {
      path: '/password/reset'
      , component: PasswordReset
      , meta: {
        requiresAuth: false
        , title: '共創未来ポータル | パスワード再設定'
      }
    },
    {
      path: '/order-scan'
      , component: OrderScan
      , meta: {
        requiresAuth: true
        , title: '共創未来ポータル | 発注スキャン'
        , hideFooter: true
        , requiresOrderPermission: true
      }
    },
    {
      path: '/return-scan'
      , component: ReturnScan
      , meta: {
        requiresAuth: true
        , title: '共想未来ポータル | 返品依頼スキャン'
        , hideFooter: true
        , requiresReturnPermission: true
      }
    },
    {
      path: '/pdf-viewer'
      , component: PdfViewerPage
      , meta: {
        requiresAuth: true
        , isPdf: true
      }
    },
    {
      path: '/pdf-viewer/order-terms'
      , component: OrderTerms
      , meta: {
        requiresAuth: false
        , title: '共創未来ポータル | 発注ルール'
        , isPdf: true
      }
    },
    {
      path: '/pdf-viewer/return-terms'
      , component: ReturnTerms
      , meta: {
        requiresAuth: false
        , title: '共創未来ポータル | 返品ルール'
        , isPdf: true
      }
    },
    {
      path: '/pdf-viewer/barcode-scan-terms'
      , component: BarcodeScanTerms
      , meta: {
        requiresAuth: false
        , title: '共創未来ポータル | バーコードスキャン機能利用規約'
        , isPdf: true
      }
    },
    {
      path: '/pdf-viewer/enif-club-terms'
      , component: EnifClubTerms
      , meta: {
        requiresAuth: false
        , title: '共創未来ポータル | ENIF-club利用規約'
        , isPdf: true
      }
    },
    {
      path: '/pdf-viewer/enif-club-document'
      , component: EnifClubDocument
      , meta: {
        requiresAuth: false
        , title: '共創未来ポータル | ENIF-club書類'
        , isPdf: true
      }
    },
    {
      path: '/pdf-viewer/manual'
      , component: Manual
      , meta: {
        requiresAuth: false
        , title: '共創未来ポータル | マニュアル'
        , isPdf: true
      }
    },
    {
      path: '/pdf-viewer/environment'
      , component: Environment
      , meta: {
        requiresAuth: false
        , title: '共創未来ポータル | サイトの利用環境'
        , isPdf: true
      }
    },
    {
      path: '/pdf-viewer/terms'
      , component: Terms
      , meta: {
        requiresAuth: false
        , title: '共創未来ポータル | 利用規約'
        , isPdf: true
      }
    },
    {
      path: '/error'
      , component: Error
      , requiresAuth: false
    },
    {
      path: '/:pathMatch(.*)*'
      , redirect: { path: '/error', query: { errorCode: '404' } }
    }
  ]
})

// 遷移のルート情報を保持
let pendingNav = null;

export const getPendingNav = () => pendingNav;
export const clearPendingNav = () => {
  pendingNav = null;
}
export const setPendingNav = (to) => {
  pendingNav = to;
}

const tryAutoLogin = async (auth) => {
  if (auth.initialized) return;
  if (auth.isLoggingOut) return;

  try {
    // セッションCookieが有効か確認（ブラウザリロード時の再認証）
    const isAuthenticated = await auth.checkAuth();
    if (!isAuthenticated) {
      return;
    }

    // ブラウザ再起動後は XSRF-TOKEN(Session) が消えるため、
    // セッションに合わせて Cookie／ヘッダ用トークンを取得する
    await auth.initCsrf();
    await auth.fetchUserData();
  } catch (error) {
    auth.user = null;
    if (error.response?.status === 401) {
      // 未認証は beforeEach 側でログイン画面へ誘導
      return;
    }
    // ネットワークエラーは axios interceptor が /error へ誘導済みのため、元の遷移だけ中断する
    if (isNetworkError(error)) {
      return false;
    }
    // サーバーエラー等はエラー画面へ
    const errorCode = error.response?.status || 'default';
    return {
      path: '/error',
      query: { errorCode: String(errorCode) },
    };
  } finally {
    auth.initialized = true;
  }
};

router.beforeEach(async (to, from) => {
  if (to.meta.skipAuthGuard) {
    return true;
  }

  // オフライン判定は navigator.onLine に頼らない（起動直後の誤判定を避ける）。
  // 実際の通信失敗時は axios interceptor → redirectToOfflineError で誘導する。

  // PDFページから戻る場合はモーダルクリーンアップをスキップ
  const isReturningFromPdf = from.meta.isPdf && !to.meta.isPdf;
  if (!isReturningFromPdf) {
    // モーダルのクリーンアップ
    document.querySelectorAll('.modal.show').forEach(el => {
      const instance = bootstrap.Modal.getInstance(el);
      instance?.hide();
    });
    document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
    document.body.classList.remove('modal-open');
  }
  const auth = useAuthStore();

  // ルートに関係なく、未初期化時は一度だけ自動ログインを試行
  if (!auth.initialized) {
    const autoLoginResult = await tryAutoLogin(auth);
    if (autoLoginResult === false) {
      return false;
    }
    if (autoLoginResult) {
      return autoLoginResult;
    }
  }

   // 公開ページ（認証不要）
  const publicPaths = ['/login', '/error', '/forgot-password', '/forgot-password/complete', '/password/reset', '/reset-password', '/change-password']
  if (publicPaths.some(path => to.path.startsWith(path))) {
    if (to.path === '/login') {
      // すでにログイン済みなら保存済みの遷移先または Top へ
      if (auth.isAuthenticated) {
        return consumePostLoginRedirect(router) ?? '/'
      }
    }
    return true
  }

  // 認証が必要なページで未ログインならログイン画面へ（ログイン後に元の URL へ）
  if (to.meta.requiresAuth && !auth.isAuthenticated) {
    setPostLoginRedirect(to.fullPath)
    return '/login'
  }

  // 発注ルール同意チェック
  if (to.meta.requiresOrderTerms) {
    if (auth.user?.isPermittedOrder && !auth.user?.isOrderTermsAgreed) {
      pendingNav = to;
      const { showModal } = modalUtil();
      showModal('orderTermsModal');
      return false;
    }
  }

  // 返品ルール同意チェック
  if (to.meta.requiresReturnTerms) {
    if(!auth.user?.isReturnTermsAgreed) {
      pendingNav = to;
      const { showModal } = modalUtil();
      showModal('returnTermsModal');
      return false;
    }
  }

  // スキャン画面URL直接入力遷移（ブラウザ版からの直接アクセス含む）はTOP画面にリダイレクト
  const navStore = useScanNavigationStore();
  if (to.path === '/order-scan') {
    if (!navStore.allowOrderScan) {
      navStore.reset();
      return '/';
    }
  }
  if (to.path === '/return-scan') {
    if (!navStore.allowReturnScan) {
      navStore.reset();
      return '/';
    }
  }

  return true
})

router.afterEach((to, from) => {
  const auth = useAuthStore();

  // PDFから戻ってきた場合にモーダルを再表示（PDF閲覧のみは対応外とする）
  const isReturningFromPdf = from.meta.isPdf && !to.meta.isPdf;
  if (isReturningFromPdf && to.query.reopenModal) {
    const { showModal } = modalUtil();
    // DOM が確実に描画された後に実行
    setTimeout(() => {
      showModal(to.query.reopenModal);
    }, 300);
  }

  // 発注TOP / 在庫問合せTOP の動的切替
  if (to.path === '/order-search') {
    document.title =
      auth.user?.orderFlg === 1 || auth.user?.orderFlg === 2
        ? '共創未来ポータル | 在庫問合せTOP'
        : '共創未来ポータル | 発注TOP';

    return;
  }
  document.title = to.meta.title || '共創未来ポータル'
})

export default router
